export default [
    {
        date: 1405764929665,
        row: 3,
        col: 3,
        segments: [
            [1, 1, 2, 2],
            [1, 3, 2, 2],
            [2, 2, 3, 3],
            [3, 2, 2, 3],
            [3, 1, 2, 2],
            [2, 1, 3, 2],
            [3, 1, 3, 3],
        ],
    },
    {
        date: 1394576160778,
        row: 3,
        col: 3,
        segments: [
            [2, 1, 2, 3],
            [2, 3, 1, 2],
            [1, 2, 2, 1],
            [2, 1, 3, 2],
            [3, 2, 2, 3],
            [2, 3, 3, 1],
            [1, 3, 3, 1],
            [1, 1, 2, 3],
            [1, 1, 3, 3],
            [2, 1, 1, 3],
            [1, 3, 3, 3],
            [2, 1, 3, 3],
            [3, 3, 3, 1],
            [1, 1, 1, 3],
        ],
    },
    {
        date: "1353471914589",
        row: 3,
        col: 3,
        segments: [
            [1, 3, 3, 1],
            [3, 1, 1, 1],
            [1, 1, 1, 3],
            [1, 3, 3, 3],
            [3, 3, 1, 1],
            [3, 1, 3, 3],
            [2, 2, 3, 2],
            [2, 2, 2, 1],
            [2, 2, 1, 2],
            [2, 2, 2, 3],
            [3, 1, 2, 2],
            [3, 3, 2, 2],
            [2, 1, 1, 2],
            [2, 1, 3, 2],
            [3, 2, 2, 3],
            [1, 2, 2, 3],
        ],
    },
    {
        date: "1353716780515",
        row: 3,
        col: 3,
        segments: [
            [3, 1, 1, 3],
            [1, 3, 2, 1],
            [2, 1, 3, 3],
            [3, 3, 1, 2],
            [1, 2, 3, 2],
            [3, 2, 1, 1],
            [1, 1, 2, 3],
            [1, 2, 2, 3],
            [2, 3, 2, 2],
            [2, 2, 1, 1],
            [1, 1, 3, 1],
            [3, 1, 3, 3],
            [3, 3, 1, 3],
            [1, 3, 1, 1],
            [3, 1, 2, 3],
            [2, 3, 2, 1],
            [2, 1, 1, 2],
            [1, 2, 3, 1],
            [3, 2, 2, 1],
            [3, 2, 2, 3],
            [3, 3, 2, 2],
            [1, 3, 3, 2],
            [3, 1, 2, 2],
        ],
    },
];
